import { faSave, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useFormikContext } from 'formik'
import React from 'react'
import { Dropdown, DropdownOption, Input } from 'src/components/Forms'
import YesNo from 'src/components/Forms/YesNo'
import { Body, Footer } from 'src/components/theme/Models/Modal'
import { Values } from './FormContext'

interface FormProps {
  toggle: () => void
  isLoading?: boolean
  hasError?: boolean
  disableSave?: boolean
  clearedFacilities?: DropdownOption[]
}

const Form: React.FC<FormProps> = (props) => {
  const { hasError, toggle, isLoading, disableSave, clearedFacilities } = props
  const { handleSubmit } = useFormikContext<Values>()
  return (
    <>
      <Body error={{
        error: 'There was an issue updating the position details.',
        show: hasError ?? false
      }}
      >
        <Input type='text' name='name' label='Name' />
        <YesNo name='staffingAgency.sdvosb' label='SDVOSB' />
        <Dropdown name='staffingAgency.clearedFacility' label='Cleared Facility' options={clearedFacilities ?? []} />
      </Body>
      <Footer
        toggle={toggle}
        onAction={handleSubmit}
        action={{
          text: 'Save',
          icon: isLoading === true ? faSpinner : faSave,
          color: 'primary',
          disabled: disableSave === true || isLoading
        }}
      />
    </>
  )
}

export default Form
